import React, { ComponentProps } from "react";

interface ChevronLeftCircleIconProps extends ComponentProps<"svg"> {
  bgColor?: string;
  chevronColor?: string;
}

export default function ChevronLeftCircleIcon({
  bgColor = "white",
  chevronColor = "white",
  ...props
}: ChevronLeftCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      {...props}
    >
      <path
        opacity="0.4"
        d="M13.0001 25.5002C6.10637 25.5002 0.500122 19.8927 0.500122 13.0002C0.500122 6.10774 6.10637 0.500244 13.0001 0.500244C19.8926 0.500244 25.5001 6.10774 25.5001 13.0002C25.5001 19.8927 19.8926 25.5002 13.0001 25.5002Z"
        fill={bgColor}
      />
      <path
        d="M14.8031 18.2761C14.5644 18.2761 14.3244 18.1848 14.1419 18.0023L9.78315 13.6648C9.6069 13.4886 9.50815 13.2498 9.50815 12.9998C9.50815 12.7511 9.6069 12.5123 9.78315 12.3361L14.1419 7.99609C14.5081 7.63109 15.1006 7.63109 15.4669 7.99859C15.8319 8.36609 15.8306 8.95984 15.4644 9.32484L11.7731 12.9998L15.4644 16.6748C15.8306 17.0398 15.8319 17.6323 15.4669 17.9998C15.2844 18.1848 15.0431 18.2761 14.8031 18.2761Z"
        fill={chevronColor}
      />
    </svg>
  );
}
